import { render, staticRenderFns } from "./MediaLibrary.vue?vue&type=template&id=f5f79458&scoped=true"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"
import style0 from "./MediaLibrary.vue?vue&type=style&index=0&id=f5f79458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f79458",
  null
  
)

export default component.exports